module.exports = __webpack_public_path__ + "media/images/icons/redcare-logo-64101f72a2445ed5eb7ec315ff074bda.png";